import { useState } from 'react';
import PropTypes from 'prop-types';
import { FaChevronDown } from 'react-icons/fa';
import { useTranslation } from '../../utils/translations';
import { formatPhone, telHref } from './familyCompat';
import './TeacherContacts.css';

/* How many people a card shows before the rest go behind "more" */
const VISIBLE = 2;

/* The teacher / leader section of a card, shared by every card style.

   A list of people, one row each: name on the left, a tappable number on the
   right (a dash when the data has none). Only the first two rows show at
   first; when there are more, a "more" control below the rows reveals the
   rest and turns into "fewer". Typography is inherited from the card, so
   each card keeps its own look. */
const TeacherContacts = ({ people }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  if (people.length === 0) return null;

  const hidden = people.length - VISIBLE;
  const shown = open ? people : people.slice(0, VISIBLE);

  return (
    <div className="tc">
      <ul className="tc-list">
        {shown.map((p) => (
          <li key={p.name} className="tc-row">
            <span className="tc-row-name">{p.name}</span>
            {p.phone ? (
              <a className="tc-phone" href={telHref(p.phone)}>
                {formatPhone(p.phone)}
              </a>
            ) : (
              <span className="tc-phone tc-phone-none">—</span>
            )}
          </li>
        ))}
      </ul>

      {hidden > 0 && (
        <button
          type="button"
          className="tc-toggle"
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          {open ? t('details.fewerTeachers') : t('details.moreTeachers', { n: hidden })}
          <FaChevronDown className="tc-toggle-chev" aria-hidden="true" />
        </button>
      )}
    </div>
  );
};

TeacherContacts.propTypes = {
  people: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      phone: PropTypes.string,
    })
  ).isRequired,
};

export default TeacherContacts;
